import React from 'react';
import fetch from 'common/services/fetch';
import store from 'common/services/storage';
import RecordList from './components/recordList';
import toast from 'components/mtToast/mtToast';
import  './confirmedRecord.scss';

class SwitchBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropped: false,
      selectedItem: {
        title: '所有活动',
        activityId: null,
        groupInfos: [{
          title: '所有套餐',
          actGroupId: null,
        }],
      },
      selectedGroup: {
        title: '所有套餐',
        actGroupId: null,
      },
      groups: [{
        title: '所有套餐',
        actGroupId: null,
      }],
    };
    this.selectAct = this.selectAct.bind(this);
    this.toggle = this.toggle.bind(this);
    document.title = '核销记录';
  }
  selectAct(item) {
    this.setState({
      selectedItem: item,
      groups: item.groupInfos,
    });
  }
  selectGroup(group) {
    this.setState({
      selectedGroup: group,
      dropped: false,
    });
    this.props.onActSelected(this.state.selectedItem, group);
  }
  toggle() {
    this.setState((state) => {
      return {
        dropped: !state.dropped,
      };
    });
  }
  render() {
    return (
      <React.Fragment>
        {
          this.state.dropped && <div className='mt-mask'></div>
        }
        <div className='switchBar'>
          <div className='selectedItem' onClick={() => this.toggle()}>
            <span>{this.state.selectedGroup.title}</span>
            { this.state.dropped ?
                <img src={require('assets/images/icon-triangle-up-grey.png')} alt='up'></img> :
                <img src={require('assets/images/icon-triangle-down-grey.png')} alt='down'></img>
            }
          </div>
          { this.state.dropped &&
            <div className='dropList'>
              <div className='left'>
                {this.props.acts.map((item, index) => {
                  return <div key={index} className={item.activityId === this.state.selectedItem.activityId?'selected':'' } onClick={() => this.selectAct(item)}>{item.title}</div>
                })}
              </div>
              <div className='right'>
                {this.state.groups.map((group, index) => {
                  return <div key={index} className={group.actGroupId === this.state.selectedGroup.actGroupId?'selected':'' } onClick={() => this.selectGroup(group)}>{group.title}</div>
                })}
              </div>
            </div>
          }
        </div>
      </React.Fragment>
    )
  }
}
class ConfirmedRecordView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      placeholderGroupIdPrefix: 'placeholderGroupIdPrefix',
      acts: [{
        title: '所有活动',
        activityId: null,
        groupInfos: [{
          title: '所有套餐',
          actGroupId: null,
        }],
      }],
      records: [],
    }
    this.handleActSelected = this.handleActSelected.bind(this);
  }
  componentDidMount() {
    this.getActs();
    this.getRecord(this.state.acts[0].activityId);
  }
  handleActSelected(item, group) {
    this.getRecord(item.activityId, group.actGroupId);
  }
  getActs() {
    const partnerId = store.get('LOGIN_UID');
    fetch.get(`/partner/bend/getVerifyRecord/${partnerId}`).then((res) => {
      // add all group
      res = res.map((i, index) => {
        if (!i.groupInfos) {
          i.groupInfos = [];
        }
        i.groupInfos.splice(0, 0, {
          title: '所有套餐',
          actGroupId: `${this.state.placeholderGroupIdPrefix}${index}`,
        });
        return i;
      });
      this.setState((state) => ({
        acts: state.acts.concat(res),
      }));
    });
  }
  getRecord(activityId, actGroupId) {
    if (actGroupId && actGroupId.indexOf(this.state.placeholderGroupIdPrefix) === 0) {
      actGroupId = null;
    }
    const params = {};
    if (activityId) {
      params.activityId = activityId;
    }
    if (actGroupId) {
      params.actGroupId = actGroupId;
    }
    const partnerId = store.get('LOGIN_UID');
    fetch.get(`/partner/bend/getVerifyRecordByActivity/${partnerId}`, params).then((res) => {
      this.setState({
        records: res,
      });
    });
  }
  tipOnClick() {
    toast.pop('在线预约强制核销');
  }
  render() {
    return (
      <div className='confirmedRecordView'>
        <SwitchBar acts={this.state.acts} onActSelected={this.handleActSelected}></SwitchBar>
        <div className='confirmedTotal'>共核销<span>{this.state.records.length}</span>张</div>
        <RecordList records={this.state.records} handleTip={this.tipOnClick}></RecordList>
      </div>
    );
  }
}
export default ConfirmedRecordView;
